<div class="create-purchase-order">
  <form [formGroup]="nonPoDataForm" class="new-orders-form">
    <mat-form-field>
      <mat-select formControlName="mineId" placeholder="Loading Facility">
        <mat-option>
          <ngx-mat-select-search
            [placeholderLabel]="'Loading Facility'"
            [noEntriesFoundLabel]="'No facility found'"
            [formControl]="filterMine"
          ></ngx-mat-select-search>
        </mat-option>

        <mat-option *ngFor="let mine of mines$$ | async" [value]="mine.id">
          {{ mine.site.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Select Mesh*</mat-label>
      <mat-select formControlName="meshId">
        <mat-option *ngFor="let mesh of meshes$$ | async" [value]="mesh.id"> {{ mesh.type }} Mesh</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="contract-container">
      <mat-form-field>
        <input matInput placeholder="Purchase Order" formControlName="purchaseOrder" autocomplete="off" />
      </mat-form-field>
      <button
        type="button"
        color="primary"
        mat-mini-fab
        (click)="startNewPo()"
        [disabled]="!(nonPoDataForm.get('meshId').value && nonPoDataForm.get('meshId').value > 0)"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </form>
  <form [formGroup]="editPoForm" class="new-orders-form" (ngSubmit)="updatePo()" *ngIf="editPoForm.enabled">
    <h3>Details</h3>
    <mat-form-field class="form-field">
      <input matInput placeholder="Total Tonnage" formControlName="totalTonnage" autocomplete="off" sa-number-input />
    </mat-form-field>
    <div class="form-row">
      <mat-form-field class="form-field">
        <input
          matInput
          placeholder="Daily Min (Tons)"
          formControlName="dailyMinTon"
          autocomplete="off"
          sa-number-input
        />
      </mat-form-field>
      <div class="spacer"></div>
      <mat-form-field class="form-field">
        <input
          matInput
          placeholder="Daily Max (Tons)"
          formControlName="dailyMaxTon"
          autocomplete="off"
          sa-number-input
        />
      </mat-form-field>
    </div>
    <mat-form-field class="form-field">
      <input matInput placeholder="Cost Per Ton" formControlName="costPerTon" autocomplete="off" saCurrencyInput />
    </mat-form-field>
    <mat-form-field class="form-field">
      <input
        matInput
        placeholder="Shortfall Penalty Cost Per Ton"
        formControlName="penaltyCostPerTon"
        autocomplete="off"
        saCurrencyInput
      />
    </mat-form-field>
    <mat-form-field class="form-field">
      <input
        matInput
        class="datepicker-input"
        placeholder="Reset daily allocation time"
        autocomplete="off"
        formControlName="resetAllocationTime"
        [owlDateTime]="resetAllocationTime"
        [owlDateTimeTrigger]="resetAllocationTime"
      />
      <owl-date-time #resetAllocationTime [pickerType]="'timer'"></owl-date-time>
    </mat-form-field>

    <mat-form-field class="form-field subscribed-users" *saFeatureFlag="'purchaseOrderAllocationNotifications'">
      <mat-select
        formControlName="subscribedSandiUsers"
        placeholder="Subscribed Users"
        multiple
        saAutomatedSelector="well-creation__subscribed-users"
      >
        <mat-option>
          <ngx-mat-select-search
            [placeholderLabel]="'Subscribed Users'"
            [noEntriesFoundLabel]="'No User found'"
            [formControl]="filterUser"
          ></ngx-mat-select-search>
        </mat-option>
        <mat-option
          *ngFor="let user of filteredUsers$ | async; trackBy: filteredUsers$ | trackByKey: 'id'"
          [value]="user.id"
        >
          <span>{{ user.name }}</span>
        </mat-option>
      </mat-select>
      <mat-hint>Select which users will receive notifications when this PO is nearing or over capacity.</mat-hint>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Permitted Fracs (leave blank for all)</mat-label>
      <mat-select formControlName="permittedFracIds" multiple>
        <mat-option *ngFor="let frac of fracs$ | async; trackBy: trackById" [value]="frac.id">
          {{ frac.jobName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <sa-network-active-button [active]="updating">
      <button
        [disabled]="this.editPoForm.invalid || this.nonPoDataForm.invalid"
        type="submit"
        mat-raised-button
        color="primary"
      >
        Create Purchase Order
      </button>
    </sa-network-active-button>
  </form>
</div>

<ng-template #newPurchaseOrder>
  <form (ngSubmit)="createPo()" class="new-po-form">
    <mat-form-field class="form-field">
      <input
        #newContractName
        matInput
        placeholder="Purchase Order Name"
        [formControl]="newContractForm"
        autocomplete="off"
      />
    </mat-form-field>
    <button type="submit" color="primary" mat-raised-button [disabled]="newContractForm.invalid">
      Create New Purchase Order
    </button>
    <button type="button" color="warn" mat-raised-button (click)="closeTab()">
      Cancel
    </button>
  </form>
</ng-template>
